import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	stack: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 4,
	},
	muted: {
		color: theme.palette.custom.textSecondary,
	},
	info: {
		display: "inline-flex",
		color: theme.palette.primary.main,
	},
	featured: {
		display: "flex",
		alignItems: "center",
		gap: 6,
	},
	issue: {
		display: "inline-flex",
		cursor: "default",
	},
	// The card is shared/category-accordion, set up as the IDX Pages sections do: 16px between cards, and a 72px header
	// that doesn't grow when opened.
	board: {
		"&&, &&.Mui-expanded": {
			margin: theme.spacing(0, 0, 2),
		},
		"&&:last-child": {
			marginBottom: 0,
		},
	},
	boardSummary: {
		"&&, &&.Mui-expanded": {
			minHeight: 72,
			padding: theme.spacing(0, 3),
		},
		"&& .MuiAccordionSummary-content": {
			margin: 0,
		},
	},
	boardHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		width: "100%",
	},
	boardTitle: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(2),
		fontSize: 18,
		fontWeight: 700,
		lineHeight: "24px",
		color: theme.palette.custom.textPrimary,
	},
	chevron: {
		flexShrink: 0,
		color: theme.palette.primary.main,
	},
	boardMeta: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(0.5),
		fontSize: 16,
		lineHeight: "20px",
		whiteSpace: "nowrap",
		color: theme.palette.custom.textPrimary,
	},
	boardWarningIcon: {
		flexShrink: 0,
		color: theme.palette.custom.warning,
	},
	boardBody: {
		overflowX: "auto",
		borderTop: `1px solid ${theme.palette.custom.borderCard}`,
	},
	empty: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.custom.textSecondary,
	},
} satisfies Record<string, CSSObject>);
